import { FC, useCallback, useMemo } from 'react'
import styles from 'components/features/socialFeed/FeedPopularTags/FeedPopularTags.styl'
import { connectShadedLoadable } from 'helpers/loadableHelpers'
import { tagsByPopularityGuard } from 'guards/feedGuards'
import { useShallowSelector, useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { tagsByPopularitySelector } from 'selectors/feedSelectors'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import Button from 'components/features/pfm/Button/Button'
import { memberSelector } from 'selectors/globalSelectors'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'

type FeedPopularTagsProps = {

}

const FeedPopularTagsComponent: FC<FeedPopularTagsProps> = (props) => {
  const {} = props

  const tagsWithRequest = useShallowSelector(tagsByPopularitySelector)
  const hadAppointedMeeting = useStoreSelector((store) => memberSelector(store).data?.info?.had_appointed_meeting ?? false)

  const dispatch = useStoreDispatch()
  const handleCoach = useCallback(() => {
    dispatch(modifyFloatingPaneActionCreator('advisor', {
      mode: 'request',
      step: 'topic',
      fields: {
        flow: 'regular',
      },
    }))
  }, [dispatch])

  const tagsChild = useMemo(() => {
    if (!tagsWithRequest || !tagsWithRequest.payload) {
      return null
    }

    return (
      <div className={ styles.tags }>
        { tagsWithRequest.payload.map(({ name }) => (
          <NavigationLink to={{ anchor: 'feedtag', id: name }} key={ name }>
            <div className={ styles.tag }>
              #{ name }
            </div>
          </NavigationLink>
        ))}
      </div>
    )
  }, [tagsWithRequest])

  return (
    <div className={ styles.feedModule }>
      <div className={ styles.questions }>Got money questions?</div>
      <div className={ styles.button1 }>
        { !hadAppointedMeeting && (
          <Button size='small' fullWidth onClick={ handleCoach }>Meet your coach</Button>
        )}
        { hadAppointedMeeting && (
          <NavigationLink to='feedposts'>
            <Button size='small' fullWidth>Ask your peers</Button>
          </NavigationLink>
        )}
      </div>
      <div className={ styles.hint }>Explore popular topics</div>
      { tagsChild }
      <div className={ styles.hint }>or</div>
      <div className={ styles.button2 }>
        { !hadAppointedMeeting && (
          <NavigationLink to='feedposts'>
            <Button size='small' fullWidth style='hollow'>Ask your peers</Button>
          </NavigationLink>
        )}
        { hadAppointedMeeting && (
          <NavigationLink to='feedposts'>
            <Button size='small' fullWidth style='hollow'>See Recent Posts</Button>
          </NavigationLink>
        )}
      </div>
    </div>
  )
}

export const FeedPopularTags = connectShadedLoadable<
  {}, {}, FeedPopularTagsProps
>(() => () => ({}), () => ({}), [tagsByPopularityGuard])(FeedPopularTagsComponent)
